const tableData = [];

export { tableData };
